import { createContext } from 'react';
import { decorate, observable, action, toJS } from 'mobx';

import api from '../api';
import * as fn from '../utilities/_functions';

export class LogicalDeviceCreate {
    id = null;
    data = {
        name: null,
        descriptionHtml: null,
        industryDeviceId: null,
    };
    industries = [];
    industryDevices = [];
    isReady = false;
    isSaving = false;
    hasUnsavedChanges = false;

    cancelLogicalDeviceCreate = null;

    initialize = () => {
        const that = this;
        this.clear();

        return new Promise((resolve, reject) => {
            Promise.all([
                api.Industries.all(),
                api.IndustryDevices.all(),
            ])
                .then(response => {
                    that.industries = response && response[0] && response[0].data && response[0].data.length > 0 ? response[0].data : [];
                    that.industryDevices = response && response[1] && response[1].data && response[1].data.length > 0 ? response[1].data : [];
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    that.isReady = true;
                })
        })
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            let option = toJS(that.data);

            if (that.hasUnsavedChanges) {
                api.LogicalDevices.create(option, (c) => { that.cancelLogicalDeviceCreate = c })
                    .then(({ data }) => {
                        that.hasUnsavedChanges = false;
                        that.id = data.id;
                        option.id = data.id;
                        resolve(option);
                    })
                    .catch(() => {
                        reject();
                    })
                    .finally(() => {
                        that.isSaving = false;
                    })
            } else {
                that.hasUnsavedChanges = false;
                that.isSaving = false;
                resolve(option);
            }
        })
    }

    clear = () => {
        this.id = null;
        this.industries.clear();
        this.industryDevices.clear();
        this.data.name = null;
        this.data.descriptionHtml = null;
        this.data.industryDeviceId = null;
        this.hasUnsavedChanges = false;

        if (fn.isFunction(this.cancelLogicalDeviceCreate)) {
            this.cancelLogicalDeviceCreate();
            this.cancelLogicalDeviceCreate = null;
        }
    }
}

decorate(LogicalDeviceCreate, {
    id: observable,
    industries: observable,
    industryDevices: observable,
    data: observable.deep,
    hasUnsavedChanges: observable,
    isReady: observable,
    isSaving: observable,
    initialize: action,
    save: action,
    clear: action,
})

export default createContext(new LogicalDeviceCreate());